"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.softwareUpgradeProposal = void 0;
var ow_1 = __importDefault(require("ow"));
var long_1 = __importDefault(require("long"));
var codec_1 = require("../../../../cosmos/v1beta1/codec");
var ow_types_1 = require("../ow.types");
var typeurl_1 = require("../../../common/constants/typeurl");
exports.softwareUpgradeProposal = function () {
    return (function () {
        function SoftwareUpgradeProposal(options) {
            ow_1.default(options, 'options', ow_types_1.owSoftwareUpgradeProposalOptions);
            this.title = options.title;
            this.description = options.description;
            this.plan = options.plan;
        }
        SoftwareUpgradeProposal.fromCosmosMsgJSON = function (msgJsonStr) {
            var parsedMsg = JSON.parse(msgJsonStr);
            if (parsedMsg['@type'] !== typeurl_1.COSMOS_MSG_TYPEURL.upgrade.SoftwareUpgradeProposal) {
                throw new Error("Expected " + typeurl_1.COSMOS_MSG_TYPEURL.upgrade.SoftwareUpgradeProposal + " but got " + parsedMsg['@type']);
            }
            var plan = parsedMsg.plan;
            var timeSecondsLong;
            var timeNanos;
            if (plan.time) {
                if (plan.time.seconds) {
                    timeSecondsLong = long_1.default.fromString(plan.time.seconds, true, 10);
                }
                if (plan.time.nanos) {
                    timeNanos = Number(plan.time.nanos);
                }
            }
            if (!plan.height) {
                throw new Error('Invalid `height` attribute in Plan.');
            }
            if (plan.upgraded_client_state && Object.keys(plan.upgraded_client_state).length > 0) {
                throw new Error('Non-empty upgraded client state is not supported.');
            }
            return new SoftwareUpgradeProposal({
                description: parsedMsg.description,
                title: parsedMsg.title,
                plan: {
                    height: long_1.default.fromString(plan.height, true, 10),
                    info: plan.info,
                    name: plan.name,
                    time: {
                        nanos: timeNanos,
                        seconds: timeSecondsLong,
                    },
                    upgradedClientState: undefined,
                },
            });
        };
        SoftwareUpgradeProposal.prototype.getEncoded = function () {
            var softwareUpgradeProposalOptions = {
                title: this.title,
                description: this.description,
                plan: this.plan,
            };
            var softwareUpgradeProposalContent = codec_1.cosmos.upgrade.v1beta1.SoftwareUpgradeProposal.create(softwareUpgradeProposalOptions);
            return codec_1.google.protobuf.Any.create({
                type_url: typeurl_1.COSMOS_MSG_TYPEURL.upgrade.SoftwareUpgradeProposal,
                value: codec_1.cosmos.upgrade.v1beta1.SoftwareUpgradeProposal.encode(softwareUpgradeProposalContent).finish(),
            });
        };
        return SoftwareUpgradeProposal;
    }());
};
//# sourceMappingURL=SoftwareUpgradeProposal.js.map